import { Link } from "react-router-dom";
import { ArrowUpRight, Users, User } from "lucide-react";
import { Layout, PageHeader } from "../components/Layout";
import { PROGRAMS, financeText } from "../lib/programs";

function ProgramCard({ p, index }) {
  return (
    <Link to={`/programs/${p.slug}`} data-testid={`program-card-${p.slug}`}
      className="eon-card group flex flex-col animate-fade-up overflow-hidden" style={{ animationDelay: `${index * 50}ms` }}>
      <div className="relative aspect-[3/2] overflow-hidden bg-eon-elevated">
        <img src={p.image} alt={p.title} loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <span className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-widest bg-white/90 text-eon-gold rounded-full px-3 py-1">{p.category === "B2B" ? "Business Solution" : "For Owners"}</span>
      </div>
      <div className="p-6 flex-1 flex flex-col">
        <h3 className="font-display text-xl font-bold text-eon-text leading-snug">{p.title}</h3>
        <p className="text-sm text-eon-muted mt-2 leading-relaxed flex-1">{p.tagline}</p>
        <div className="mt-5 flex items-center justify-between">
          <span className="font-mono text-eon-gold text-sm font-semibold">{p.priceFrom}</span>
          <ArrowUpRight size={18} className="text-eon-muted group-hover:text-eon-gold transition-colors" />
        </div>
        <p className="text-[11px] text-eon-muted/80 mt-2">{financeText(p)}</p>
      </div>
    </Link>
  );
}

export default function Programs({ ownerOnly = false }) {
  const b2c = PROGRAMS.filter((p) => p.category === "B2C");
  const b2b = PROGRAMS.filter((p) => p.category === "B2B");
  return (
    <Layout>
      <PageHeader
        label={ownerOnly ? "EON Boerboels" : "E.O.N Business Solutions"}
        title={ownerOnly ? "Programs for Owners" : "Build. Systemize. Scale."}
        subtitle={ownerOnly ? "Explore our existing canine training and stud-service programs. View each program for details." : "Explore business infrastructure and consulting, with a separate collection of canine programs for owners."}
      />
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-16 space-y-20">
        <Link className="inline-block underline font-semibold" to={ownerOnly ? "/programs" : "/boerboels/programs"}>{ownerOnly ? "View corporate business programs" : "View the separate canine owner programs"}</Link>
        {!ownerOnly && <section data-testid="programs-b2b">
          <div className="flex items-center gap-3 mb-8">
            <Users size={22} className="text-eon-gold" />
            <h2 className="eon-heading text-3xl sm:text-4xl text-eon-text">Business Solutions</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {b2b.map((p, i) => <ProgramCard key={p.slug} p={p} index={i} />)}
          </div>
        </section>}

        <section data-testid="programs-b2c">
          <div className="flex items-center gap-3 mb-8">
            <User size={22} className="text-eon-gold" />
            <h2 className="eon-heading text-3xl sm:text-4xl text-eon-text">Programs for Owners</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {b2c.map((p, i) => <ProgramCard key={p.slug} p={p} index={i} />)}
          </div>
        </section>
      </div>
    </Layout>
  );
}